import React, {useEffect, useState} from "react";
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Typography,
} from "@material-ui/core";
import {useTranslate} from "@tolgee/react";
import {APP_PATH} from "view/routes";
import PublicLanguagePicker from "view/components/LanguagePicker/PublicLanguagePicker";
import {
  redirectToAppHome,
  subscribeToAuthSessionEvents,
} from "tools/auth/sessionSync";
import useStyles from "./style";

const AUTO_REDIRECT_DELAY_MS = 2500;

const SessionChanged: React.FC = () => {
  const classes = useStyles();
  const {t} = useTranslate();
  const [isRedirecting, setIsRedirecting] = useState(false);

  const handleContinue = () => {
    window.location.replace(APP_PATH);
  };

  useEffect(() => {
    let timeoutId: number | undefined;
    let scheduled = false;

    const unsubscribe = subscribeToAuthSessionEvents((event) => {
      if (event.type !== "login" || scheduled) {
        return;
      }

      scheduled = true;
      setIsRedirecting(true);
      timeoutId = window.setTimeout(redirectToAppHome, AUTO_REDIRECT_DELAY_MS);
    });

    return () => {
      unsubscribe();
      if (timeoutId !== undefined) {
        window.clearTimeout(timeoutId);
      }
    };
  }, []);

  return (
    <Box className={classes.content}>
      <Box className={classes.main}>
        <Paper elevation={0} className={classes.paper}>
          {isRedirecting ? (
            <>
              <CircularProgress size={36} className={classes.loader} />
              <Typography className={classes.title}>
                {t("global.session_changed.signed_in_title")}
              </Typography>
              <Typography variant="body2" className={classes.description}>
                {t("global.session_changed.signed_in_description")}
              </Typography>
            </>
          ) : (
            <>
              <Typography className={classes.title}>
                {t("global.session_changed.logged_out_title")}
              </Typography>
              <Typography variant="body2" className={classes.description}>
                {t("global.session_changed.logged_out_description")}
              </Typography>
              <Button
                variant="contained"
                color="primary"
                disableElevation
                className={classes.button}
                onClick={handleContinue}
              >
                {t("global.login.login_button")}
              </Button>
            </>
          )}
        </Paper>
      </Box>
      <Box className={classes.footer}>
        <PublicLanguagePicker />
      </Box>
    </Box>
  );
};

export default SessionChanged;
